import omit from 'lodash-es/omit'
import * as queryString from 'query-string'

import sitesConfig from '../../../config/sites'
import { ILocationParams } from '../../reducers/reactRouterLocation'
import { decodeDashes, formatSortParam } from './format'
import {
  sanitizeLocationParam,
  sanitizeQueryParams,
  securitySanitizeString
} from './sanitize'

const includesAny = (testString: string, subStrings: string[]) => {
  return new RegExp(subStrings.join('|')).test(testString)
}

const conditionallyDecodeDashes = (paramString: string) => {
  const reservedParams = [
    'in%2Dgraphics',
    'with%2Dgraphics',
    'graphics%2Dwith',
    'graphics%2Din',
    '%2Dand%2D',
    '%2Din%2D'
  ]
  if (includesAny(paramString, reservedParams)) {
    return paramString
  } else {
    return decodeDashes(paramString)
  }
}

const makeSearchLink = (params: ILocationParams) => {
  let url = ''
  const terms =
    params.term &&
    conditionallyDecodeDashes(sanitizeLocationParam(params.term, ' '))
  const tags =
    params.tags &&
    conditionallyDecodeDashes(sanitizeLocationParam(params.tags))
      .split('+')
      .sort()
      .join('+')
  const categories = params.category === 'all' ? null : params.category

  const queryParamsToOmit: string[] = ['category', 'tags', 'term', 'page']

  if (terms && tags && categories) {
    url = `/${terms}-and-${tags}-graphics-in-${categories}`
  } else if (terms && categories) {
    url = `/graphics-with-${terms}-in-${categories}`
  } else if (tags && categories) {
    url = `/${tags}-graphics-in-${categories}`
  } else if (terms && tags) {
    url = `/${terms}-and-${tags}-graphics`
  } else if (terms) {
    url = `/${terms}-in-graphics`
  } else if (tags) {
    url = `/${tags}-graphics`
  } else if (categories) {
    url = `/${categories}`
  } else if (params.attribute_key && params.attribute_value) {
    queryParamsToOmit.push('attribute_key', 'attribute_value')
    url = `/attributes/${params.attribute_key}/${params.attribute_value}`
  } else {
    url = `/all-graphics`
  }

  const formattedQueryParams = formatSortParam(params)
  const omittedQueryParams = omit(formattedQueryParams, queryParamsToOmit)
  const sanitizedQueryParams = sanitizeQueryParams(omittedQueryParams)
  const stringifiedQueryParams = Object.keys(sanitizedQueryParams).length
    ? `?${queryString.stringify(sanitizedQueryParams, { encode: false })}`
    : ''

  if (params.page && Number(params.page) > 1) {
    const { max_pages_count } = sitesConfig.defaults.common
    const page =
      Number(params.page) > max_pages_count ? `${max_pages_count}` : params.page
    url += `/pg-${page}`
  }

  return securitySanitizeString(`${url}${stringifiedQueryParams}`)
}

export default makeSearchLink
